import { gql } from "@apollo/client";

export const SET_OFFER_DETAIL_ON_DOCUMENT = gql`
  mutation setOfferDetailOnDocument($input: SetOfferDetailOnDocumentInput!) {
    setOfferDetailOnDocument(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const COMPUTE_RCA_QUOTATION = gql`
  mutation computeRCAQuotation($input: ComputeRCAQuotationInput!) {
    computeRCAQuotation(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_INSURANCE_OFFERS = gql`
  mutation updateInsuranceOffers($input: UpdateInsuranceOffersInput!) {
    updateInsuranceOffers(input: $input) {
      commandId
      correlationId
    }
  }
`;
